import axios, { AxiosError } from 'axios'

import { ENV } from '@/common/constants/env'
import { RequestInterceptors } from '@/common/utils/requestInterceptors'
import { ResponseErrorInterceptors } from '@/common/utils/responseErrorInterceptors'

type WhereClause =
  | string
  | boolean
  | object
  | string[]
  | boolean[]
  | object[]
  | ApiWhere[]
  | ApiWhere
  | undefined

export interface ApiWhere {
  [key: string]: WhereClause
  AND?: ApiWhere[]
  OR?: ApiWhere[]
}

export interface ApiError {
  status: number
  timestamp: string
  path: string
  errors: string[]
  friendlyMessage: string
}

export interface APIPaginated<T> {
  items: T[]
  meta: {
    currentPage: number
    itemCount: number
    itemsPerPage: number
    totalItems: number
    totalPages: number
  }
}

const backend = axios.create({
  baseURL: ENV.VITE_BACKEND_URL,
})

backend.interceptors.request.use((config) => {
  return new RequestInterceptors(config)
    .setTokenHeader()
    .stringifyParams()
    .build()
})

backend.interceptors.response.use(
  (res) => res,
  (err: AxiosError<ApiError>) => {
    return new ResponseErrorInterceptors(err).disconnectUser().build()
  },
)

const dashboard = axios.create({
  baseURL: ENV.VITE_DASHBOARD_URL,
})

export const api = {
  backend,
  dashboard,
}
